'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import MakersReserveLogo from './MakersReserveLogo';

import styles from './MakersReserveHero.module.scss';

const PRODUCT_MOBILE =
    'https://images.ctfassets.net/j8tkpy1gjhi5/7JOwAKaXnMq6PGPoaJWDfj/eeeb820fcb6fc0cff0bd2d6beb2584ba/8e0d6971669b6e6db6ff48293b2c3bc9877a4123.png';

const PRODUCT_DESKTOP =
    'https://images.ctfassets.net/j8tkpy1gjhi5/64Zi5GEUc52BXtMU4FUPYc/9b341266d9aa6cf90e5bf128c3fc8fc0/hero-makers-reserve-desktop__1_.png';

const BUTTON_CTA = {
    text: 'Where to Buy',
    style: 'makersFilled-brown-gold',
    link: {
        slug: 'where-to-buy',
    },
    iconType: 'location',
};

const MakersReserveHero = () => {
    return (
        <div className={cx(styles.root)}>
            <div className={styles.hero}>
                <div className={styles.inner}>
                    <div className={styles.headingGroup}>
                        <div className={styles.lockup}>
                            <div className={styles.lockupLogo}>
                                <MakersReserveLogo />
                            </div>
                            <Text
                                className={styles.title}
                                baseTheme="makers48"
                                themes={{ large: 'makers60' }}
                                as="h1"
                            >
                                Patiently aged cheddar
                            </Text>
                            <ButtonCTA className={styles.cta} {...BUTTON_CTA} />
                        </div>
                        <div className={styles.heroImage}>
                            <Img
                                className={styles.image}
                                src={PRODUCT_MOBILE}
                                fallbackImageWidth={768}
                                alt={
                                    'Group of Tillamook Makers Reserve products'
                                }
                                priority
                                customSources={[
                                    {
                                        breakpoint: 1280,
                                        src: PRODUCT_DESKTOP,
                                        imageWidth: 2500,
                                    },
                                    {
                                        breakpoint: 768,
                                        src: PRODUCT_DESKTOP,
                                        imageWidth: 1920,
                                    },
                                    {
                                        src: PRODUCT_MOBILE,
                                        imageWidth: 1280,
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MakersReserveHero;
